class ProductSectionsBlock extends HTMLElement {
  constructor() {
    super();

    this.terms = this.querySelectorAll('[data-term]');
    this.sections = this.querySelectorAll('.block-product-sections__section');
  }

  connectedCallback() {
    this.terms.forEach(term => {
      term.addEventListener('click', () => {
        this.terms.forEach(t => t.classList.toggle('is-active', t === term));
        this.applyFilter(term.dataset.term);
      });
    });
  }

  applyFilter(term) {
    this.sections.forEach(section => {
      const products = section.querySelectorAll('.block-product-sections__product');
      let visibleCount = 0;

      products.forEach(product => {
        const tags = (product.dataset.tags || '').split(',').filter(Boolean);
        const visible = term === 'all' || tags.includes(term);
        product.hidden = !visible;

        if (visible) {
          visibleCount++;
        }
      });

      const grid = section.querySelector('.block-posts__items');
      const empty = section.querySelector('.block-product-sections__empty');

      if (grid) {
        grid.style.display = visibleCount === 0 ? 'none' : '';
      }

      if (empty) {
        empty.style.display = visibleCount === 0 ? '' : 'none';
      }
    });
  }
}

customElements.define('product-sections-block', ProductSectionsBlock);
